import { onDocumentReady } from './utils';
import Footer from './components/footer';
import Grist50PastMultiple from './components/grist50-past';

onDocumentReady(() => {

  new Footer();

  // This is an example of how to do code splitting. The JS in this
  // referenced file will only be loaded on that page. Good for
  // when you have a large amount of JS only needed in one place
  //
  //  if (document.querySelector('#js-process')) {
  //    import(/* webpackChunkName: "process" */ './pages/process')
  //      .then(module => {
  //        const Process = module.default;
  //        this.process = new Process();
  //      });
  //  }
});


onDocumentReady(() => {

  if ( document.querySelector('.grist50-slide-items-multiple' ) ) {
    new Grist50PastMultiple();
  }

});
